import { useState,useEffect,useContext } from 'react';
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom'; 
import { Icon } from '@iconify/react/dist/iconify.js';
import { AuthContext } from './AuthContext';
const StudentSubHeaderBar = () => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate(); 
    const location = useLocation();
    const isOnDashboard = location.pathname === '/student/dashboard';
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState('');
    
    useEffect(() => {
        axios
        .get(`/api/student/get-switch-student-lists`)
        .then((res) => {
            if (res.data.success) {
                setStudents(res.data.students);
            }
        })
        .catch((err) => {
            console.error('Failed to fetch students', err);
        });
    }, []);

    const handleChange = async (e) => {
        const selectedId = e.target.value;
        setSelectedStudent(selectedId);

        try {
            const switchResponse = await axios.post('/api/student/switch-student', {
                switch_regi_id: selectedId
            });

            const { username, password ,academic_year ,loginas ,regi_id } = switchResponse.data;
            
            const { data } = await axios.post('/api/auth/login', { username, password ,academic_year ,loginas ,regi_id });
            if (data.status === 'ok') {
                const loginAs = data.user?.loginas || 'Student';
                window.location = loginAs === 'Student' ? '/student/dashboard' : '/teacher/dashboard';
            } else {
                console.error('Login failed:', data);
            }

        } catch (error) {
            console.error('Error during student switch:', error);
        }
    };

    return (
        <div className="navbar-header">
            <div className="row">
                <div className="col-6 px-1">
                    <div className="">
                        <select
                            className='form-select'
                            name="switch_student"
                            id="switch_student"
                            value={selectedStudent ? selectedStudent:user.user.regi_id}
                            onChange={handleChange}
                            >
                            <option value="">Switch Student</option>
                            {students.map((student) => (
                                <option
                                    key={student.regi_id}
                                    value={student.regi_id}
                                    disabled={student.regi_id === user.user.regi_id}
                                >
                                    {student.student_first_name} {student.student_last_name} ({student.Class?.class})
                                </option>
                                ))
                            }
                        </select> 
                    </div>
                </div>
                <div className="col-6 px-1">
                    <div className="pull-right">
                        {!isOnDashboard && (
                            <button className='btn btn-neutral-900 text-base radius-8 px-10 py-11' onClick={() => navigate(-1)}>
                                <span className="h6 mt-0 mb-0 mobile-view-icon-hide"><Icon icon="iconoir:undo" />&nbsp;</span> 
                                Back
                            </button>
                        )}
                        &nbsp;
                        <button className='btn btn-warning-600 radius-8 px-10 py-11' onClick={() => navigate(0)}>
                            <span className="h6 mt-0 mb-0 mobile-view-icon-hide"><Icon icon="iconoir:refresh" />&nbsp;</span> 
                            Refresh
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
} 
export default StudentSubHeaderBar;